


















































import { Vue, Component } from 'vue-property-decorator'
import * as PDFJS from 'pdfjs-dist/legacy/build/pdf.js'

interface PageHeightRangParams {
  offsetTop: number,
  height: number,
  start: number,
  end: number
}

@Component({
  directives: {
    scroll: {
      bind (el, binding, vnode) {
        let timer: any
        el.addEventListener('scroll', function () {
          // 滚动加载
          const {
            limitLastPage,
            pdfPages,
            loadingPage
          } = vnode.context as any
          if (!loadingPage && (limitLastPage !== pdfPages) && (this.scrollTop > (this.scrollHeight - 2500))) {
            (vnode.context as any).handleLoadPage(2)
          }

          // 更新页码
          if (timer) clearTimeout(timer)
          timer = setTimeout(() => {
            const {
              currentPage,
              pageHeightRang
            } = vnode.context as any
            const len = pageHeightRang.length
            for (let i = 0; i < len; i++) {
              const {
                start,
                end
              } = pageHeightRang[i]
              if (this.scrollTop > start && this.scrollTop < end) {
                currentPage !== (i + 1) && ((vnode.context as any).currentPage = i + 1)
                break
              }
            }
          }, 10)
        }, { capture: false, passive: false, once: false })
      }
    }
  }
})
export default class CustomPdf extends Vue {
  // data
  path = ''
  showLoading = false
  loadingPercentage = 0
  loadingPage = false
  timer: number | null = null
  pdfDoc: any = null
  currentPage = 1
  pdfPages = 0 // 总页数
  limitLastPage = 0 // 当前显示至
  pdfScales: number[] = []
  rotations: number[] = []
  pageHeightRang: PageHeightRangParams[] = []

  created (): void {
    this.path = this.$route.query.path as string
    this.initPdf()
  }

  // 初始化pdf
  initPdf (): void {
    const self = this
    self.showLoading = true

    PDFJS.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/legacy/build/pdf.worker.entry')
    const loadingTask = PDFJS.getDocument({
      url: this.path,
      rangeChunkSize: 65536 * 160,
      disableAutoFetch: true
    })

    // 加载文件进度
    loadingTask.onProgress = function (data: any) {
      const {
        loaded,
        total
      } = data
      const loadingPercentage = Number((loaded / total * 100).toFixed(0))
      self.loadingPercentage = loadingPercentage > 100 ? 100 : loadingPercentage
    }

    loadingTask.promise.then((pdfDoc: any) => {
      setTimeout(() => {
        self.showLoading = false
      }, 1000)
      self.pdfDoc = pdfDoc
      self.pdfPages = pdfDoc.numPages
      self.$nextTick(() => {
        self.handleLoadPage(10)
      })
    })
  }

  // 加载指定页面内容
  handleLoadPage (loadNum: number): void {
    this.loadingPage = true
    const pdfPages = this.pdfPages
    const originLimitLastPage = this.limitLastPage
    const newLimitLastPage = originLimitLastPage + loadNum
    const limitLastPage = pdfPages > newLimitLastPage ? newLimitLastPage : pdfPages

    this.limitLastPage = limitLastPage
    this.initPage(originLimitLastPage + 1, limitLastPage)
    this.loadingPage = false
  }

  initPage (startNum: number, endNum: number): void {
    const self = this

    this.pdfDoc.getPage(startNum).then((page: any) => {
      const canvas: any = document.getElementById(`pdf-canvas-${startNum}`)
      const ctx: any = canvas.getContext('2d')
      const pageRotation = Number(page._pageInfo.rotate) || 0
      self.rotations.push(pageRotation)
      const initialScale = 1.4
      self.pdfScales.push(initialScale)

      const viewport = page.getViewport({
        scale: initialScale,
        rotation: pageRotation
      })
      canvas.width = viewport.width
      canvas.height = viewport.height

      const offsetTop = canvas.offsetTop
      self.pageHeightRang.push({
        offsetTop,
        height: viewport.height,
        start: offsetTop - 100,
        end: offsetTop + viewport.height - 100
      })

      const renderContext = {
        canvasContext: ctx,
        viewport: viewport
      }
      page.render(renderContext)
      const nextNum = startNum + 1
      if (endNum) {
        nextNum <= endNum && self.initPage(nextNum, endNum)
      }
    })
  }

  toZoomIn (): void {
    const currentPage = this.currentPage
    const currentIndex = currentPage - 1
    const pdfScales = this.pdfScales.concat([])
    const currentPagePdfScale = pdfScales[currentIndex]
    const newPdfScale = currentPagePdfScale + 0.2

    pdfScales.splice(currentIndex, 1, newPdfScale)
    this.pdfScales = pdfScales
    this.renderPage(currentPage)
  }

  toZoomOut (): void {
    const currentPage = this.currentPage
    const currentIndex = currentPage - 1
    const pdfScales = this.pdfScales.concat([])
    const currentPagePdfScale = pdfScales[currentIndex]
    const newPdfScale = currentPagePdfScale - 0.2

    pdfScales.splice(currentIndex, 1, newPdfScale)
    this.pdfScales = pdfScales
    this.renderPage(currentPage)
  }

  toCW (): void {
    const currentPage = this.currentPage
    const currentIndex = currentPage - 1
    const rotations = this.rotations.concat([])
    const currentPageRotation = rotations[currentIndex]
    const newRotation = (currentPageRotation + 90) % 360

    rotations.splice(currentIndex, 1, newRotation)
    this.rotations = rotations
    this.renderPage(currentPage)
  }

  toCCW (): void {
    const currentPage = this.currentPage
    const currentIndex = currentPage - 1
    const rotations = this.rotations.concat([])
    const currentPageRotation = rotations[currentIndex]
    const newRotation = (currentPageRotation - 90) % 360

    rotations.splice(currentIndex, 1, newRotation)
    this.rotations = rotations
    this.renderPage(currentPage)
  }

  renderPage (startNum: number): void {
    const self = this

    this.pdfDoc.getPage(startNum).then((page: any) => {
      const canvas: any = document.getElementById(`pdf-canvas-${startNum}`)
      const currentIndex = startNum - 1
      const ctx: any = canvas.getContext('2d')
      const viewport = page.getViewport({
        scale: self.pdfScales[currentIndex],
        rotation: self.rotations[currentIndex]
      })
      canvas.width = viewport.width
      canvas.height = viewport.height

      const offsetTop = canvas.offsetTop
      self.pageHeightRang.splice(currentIndex, 1, {
        offsetTop,
        height: viewport.height,
        start: offsetTop - 100,
        end: offsetTop + viewport.height - 100
      })

      const renderContext = {
        canvasContext: ctx,
        viewport: viewport
      }
      page.render(renderContext)
      self.updatePageHeightRang(startNum)
    })
  }

  // 更新页数大小范围
  updatePageHeightRang (startNum: number): void {
    const pageHeightRang = this.pageHeightRang.concat([])
    const len = pageHeightRang.length

    for (let i = startNum - 1; i < len; i++) {
      const canvas: any = document.getElementById(`pdf-canvas-${i + 1}`)
      const height = pageHeightRang[i].height
      const newOffsetTop = canvas.offsetTop
      pageHeightRang.splice(i, 1, {
        offsetTop: newOffsetTop,
        height,
        start: newOffsetTop - 100,
        end: newOffsetTop + height - 100
      })
    }

    this.pageHeightRang = pageHeightRang
  }
}
